import { render, staticRenderFns } from "./Formscaptured.vue?vue&type=template&id=55a6f46a&"
import script from "./Formscaptured.vue?vue&type=script&lang=js&"
export * from "./Formscaptured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports